
import {Component, Prop, Vue} from 'vue-property-decorator';
import {DescDocument, ParamValueDocument} from '@/models/parameter.model';
import {appIcon} from '@/shared/document.icon';
import {SCAPIN_ORANGE} from '@/configs/colors';
import {JisonParser} from '@/shared/jison/jison.parser';

@Component
export default class SbDetailsParameter extends Vue {
  // Les props
  @Prop() private param!: ParamValueDocument
  @Prop({default: false}) private editable!: boolean

  // Les propriétés
  private backgroundColor = `background-color: ${SCAPIN_ORANGE}`
  private validExp = [this.validExpression];

  // Les propriétés calculées
  private get paramDesc(): DescDocument | null {
    return this.param && this.param.descId
  }

  private get requiredColor() {
    return this.paramDesc ? this.paramDesc.required ? 'error' : 'success' : undefined
  }

  private get requiredIcon() {
    return this.paramDesc ? this.paramDesc.required ? appIcon('param.required') : appIcon('param.optional') : ''
  }

  private get jparser() {
    if (this.paramDesc) {
      return JisonParser.builder(this.paramDesc as DescDocument)
    } else {
      return null;
    }
  }

  private get hint(): string {
    let doc: string = ''
    if (this.paramDesc) {
      doc = this.paramDesc.documentation ? this.paramDesc.documentation : ''
      if (this.paramDesc.options && this.paramDesc.options.length) {
        const opt = this.paramDesc.options.join(', ')
        doc += ': ' + opt
      }
    }
    return doc
  }

  // Les hooks
  // Les méthodes surveillées
  // Les méthodes d'instance
  private validExpression(exp: string) {
    // console.log('validExpression :', exp);
    if (exp.length === 0) {
      return this.param.descId.required ? 'This parameter is required' : true;
    } else {
      return this.jparser ? this.jparser.exec(exp) : 'Parser not found';
    }
  }

}
